import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { ExportParams } from '../types/qualityEvent';
import exportsApi from '../api/exports.api';
import { Export } from '../types/exports';
import { useMemo } from 'react';
import ExportUtil from '../utils/exportUtils';
import { useFlags } from '../external/LaunchDarklyAdapter';

const stripColumnsUnlessPdf = (payload: ExportParams): ExportParams => {
  if (payload.format === 'pdf') {
    return payload;
  }
  const { columns, ...withoutColumns } = payload;
  return withoutColumns;
};

export const useCreateExport = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const multiSelectEventsList = useFlags('multiSelectEventsList');
  const exportUtil = useMemo(
    () => new ExportUtil(showToast, multiSelectEventsList),
    [showToast, multiSelectEventsList],
  );
  return useMutation(
    (payload: ExportParams) => {
      const params = stripColumnsUnlessPdf(payload);
      return multiSelectEventsList
        ? (exportsApi.createExportSearch(companyId, params) as Promise<unknown>)
        : exportsApi.createExport(companyId, params);
    },
    {
      onSuccess: (data) => {
        const id = multiSelectEventsList ? (data as { task_id?: string }).task_id : (data as Export).id;
        if (id) {
          exportUtil.displayExportStatus(companyId, id);
        }
      },
      onError: () => {
        exportUtil.displayErrorTryingToExport('failedToCreateEventExport');
      },
    },
  );
};
